export default __webpack_public_path__ + "static/nspp-sponsor-imls-c9623af52194d427b2cfe2a850e2be03.png";